import {
  EnumFormGenComponentType,
  type IFormGenContext,
  type IFormGenSchema,
  type TFormGenUiSchema,
  type TJSONSchema,
} from "@artifact-management/json-dynamic-form";
import type { Control, FieldValues, UseFormSetValue } from "react-hook-form";
import { FormGenAlert } from "./Alert";
import { FormGenInput } from "./Inputs";
import { FormGenTitle } from "./Title";

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export interface IFormGenComponentProps<Schema extends TJSONSchema, T extends FieldValues = any> {
  control: Control<T>;
  setValue: UseFormSetValue<T>;
  schema: IFormGenSchema<Schema>;
  parsedJsonSchema: TJSONSchema;
  uiSchemaIndex: number;
  uiSchemaElement: TFormGenUiSchema<Schema>;
  context?: IFormGenContext;
}

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const FormGenComponent = <Schema extends TJSONSchema, T extends FieldValues = any>({
  uiSchemaElement,
  ...props
}: IFormGenComponentProps<Schema, T>) => {
  switch (uiSchemaElement.type) {
    case EnumFormGenComponentType.INPUT:
      return <FormGenInput uiSchemaElement={uiSchemaElement} {...props} />;
    case EnumFormGenComponentType.ALERT:
      return <FormGenAlert uiSchemaElement={uiSchemaElement} {...props} />;
    case EnumFormGenComponentType.TITLE:
      return <FormGenTitle uiSchemaElement={uiSchemaElement} {...props} />;
    default:
      return null;
  }
};
